import React, { useEffect } from 'react'
import { connect } from 'react-redux';
import { currentWidget } from '../../action/action';
import { sendAnalytics } from '../../action/homeAction';
import { getDefaultAnalyticsLabel } from '../../layout2.0/JS/utility';
import { CMSPath } from '../../config/constant';
import { withTranslation } from 'react-i18next';


function SelectAuthOption(props) {
	let onlyOneValidationFlow = false;
	const {t}=props;
	
    useEffect(() => {
        props.currentWidget({widgetType: true});

		let label = getDefaultAnalyticsLabel({appVersion: props.installedAppVersion ? `${props.installedAppVersion}(${props.installedAppBuildNo})` : ""})
        props.sendAnalytics(
            props.guestDetail, 
            "Digital Door Key", 
            "VERIFICATION OPTIONS", 
            {...label, "layoutTab": props.currentHomePage.tabName, "element": "widget",  "pageName": "AUTH OPTIONS", "widgetSessionId": localStorage.getItem("doorKeySessionToken")},
            0, 
            props.guestIsLoggedIn,
            false
        );
	
		if(props.supportedMethods.length>1){
			onlyOneValidationFlow = false;
		}else{
			if(props.otpEnabled){
				props.onOptionClick("OTP")
				return;
			}
	
			if(props.qrOnTVEnabled){
				props.onOptionClick("QRonTV")
				return;
			}
	
			if(props.fdEnabled){
				props.onOptionClick("FrontdeskAPI")
				return;
			}
		}
    },[])

  return (
    <div class="main-container">
		{ !onlyOneValidationFlow && <>
		<header class="inner-pages subpages no-background">
			<a onClick={props.goBack} class="button-back"></a>
			<div class="heading align-center">
				<div class="splash-brand">
					<img src={`${CMSPath}${props.logo}`} />
				</div>
				{/* <p class="bold">Door Key</p> */}
			</div>
		</header>
		<section id="doorLocks" class="widgets padding-bottom-2 margin-0 select-door-auth-option">

			<div class="widget-header">
				<div class="widget-header-title">{t('door_key_auth.options_header') ||  "Door Key"} </div>
			</div>

			<div class="widgets">
				<div class="row">
					<div class="col">
						<div class="unlock-container door-locked">
							<h1 class="align-center"> {t("door_key_auth.options_subheading") ||  "Select method to authorize your phone"}</h1>
							<p class="heading">Choose your preferred method to authenticate your phone for the Digital Door Key</p>
							<div class="lg-buttons multi">
								{props.otpEnabled && <><button onClick={() => props.onOptionClick("OTP")}>
									<div class="icon">
										{/* <svg id="Layer_1" height="512" viewBox="0 0 24 24" width="512" xmlns="http://www.w3.org/2000/svg" data-name="Layer 1"><path d="m15 17a1 1 0 0 1 -1 1h-4a1 1 0 0 1 0-2h4a1 1 0 0 1 1 1zm-.293-9.707a1 1 0 0 0 -1.414 0l-1.293 1.293-1.293-1.293a1 1 0 1 0 -1.414 1.414l1.293 1.293-1.293 1.293a1 1 0 1 0 1.414 1.414l1.293-1.293 1.293 1.293a1 1 0 0 0 1.414-1.414l-1.293-1.293 1.293-1.293a1 1 0 0 0 0-1.414zm7.293 8.707h-4a1 1 0 0 0 0 2h4a1 1 0 0 0 0-2zm-.586-6 1.293-1.293a1 1 0 1 0 -1.414-1.414l-1.293 1.293-1.293-1.293a1 1 0 1 0 -1.414 1.414l1.293 1.293-1.293 1.293a1 1 0 1 0 1.414 1.414l1.293-1.293 1.293 1.293a1 1 0 0 0 1.414-1.414zm-15.414 6h-4a1 1 0 0 0 0 2h4a1 1 0 0 0 0-2zm.707-8.707a1 1 0 0 0 -1.414 0l-1.293 1.293-1.293-1.293a1 1 0 1 0 -1.414 1.414l1.293 1.293-1.293 1.293a1 1 0 1 0 1.414 1.414l1.293-1.293 1.293 1.293a1 1 0 1 0 1.414-1.414l-1.293-1.293 1.293-1.293a1 1 0 0 0 0-1.414z"/></svg> */}
										<svg id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 63.8 23.49" fill='#fff'><g id="Layer_1-2" data-name="Layer 1"><path class="cls-1" d="m29.89,21.36c0,1.18-.96,2.13-2.13,2.13h-8.53c-1.18,0-2.13-.96-2.13-2.13s.96-2.13,2.13-2.13h8.53c1.18,0,2.13.96,2.13,2.13Zm-.63-20.71c-.83-.83-2.18-.83-3.02,0l-2.76,2.76-2.76-2.76c-.82-.85-2.17-.87-3.02-.05-.85.82-.87,2.17-.05,3.02.02.02.03.04.05.05l2.76,2.76-2.76,2.76c-.85.82-.87,2.17-.05,3.02s2.17.87,3.02.05c.02-.02.04-.03.05-.05l2.76-2.76,2.76,2.76c.85.82,2.2.8,3.02-.05.8-.83.8-2.14,0-2.96l-2.76-2.76,2.76-2.76c.83-.83.83-2.18,0-3.02h0Zm15.56,18.57h-8.53c-1.18,0-2.13.96-2.13,2.13s.96,2.13,2.13,2.13h8.53c1.18,0,2.13-.96,2.13-2.13s-.96-2.13-2.13-2.13Zm-1.25-12.8l2.76-2.76c.85-.82.87-2.17.05-3.02-.82-.85-2.17-.87-3.02-.05-.02.02-.04.03-.05.05l-2.76,2.76-2.76-2.76c-.82-.85-2.17-.87-3.02-.05-.85.82-.87,2.17-.05,3.02.02.02.03.04.05.05l2.76,2.76-2.76,2.76c-.85.82-.87,2.17-.05,3.02.82.85,2.17.87,3.02.05.02-.02.04-.03.05-.05l2.76-2.76,2.76,2.76c.85.82,2.2.8,3.02-.05.8-.83.8-2.14,0-2.96l-2.76-2.76Zm18.06,12.8h-8.53c-1.18,0-2.13.96-2.13,2.13s.96,2.13,2.13,2.13h8.53c1.18,0,2.13-.96,2.13-2.13s-.96-2.13-2.13-2.13Zm-1.25-12.8l2.76-2.76c.85-.82.87-2.17.05-3.02-.82-.85-2.17-.87-3.02-.05-.02.02-.04.03-.05.05l-2.76,2.76-2.76-2.76c-.82-.85-2.17-.87-3.02-.05-.85.82-.87,2.17-.05,3.02.02.02.03.04.05.05l2.76,2.76-2.76,2.76c-.85.82-.87,2.17-.05,3.02.82.85,2.17.87,3.02.05.02-.02.04-.03.05-.05l2.76-2.76,2.76,2.76c.85.82,2.2.8,3.02-.05.8-.83.8-2.14,0-2.96l-2.76-2.76ZM10.69,19.23H2.16C.98,19.23.03,20.18.03,21.36s.96,2.13,2.13,2.13h8.53c1.18,0,2.13-.96,2.13-2.13s-.96-2.13-2.13-2.13ZM12.2.65c-.83-.83-2.18-.83-3.02,0l-2.76,2.76L3.67.65C2.85-.2,1.5-.22.65.6c-.85.82-.87,2.17-.05,3.02.02.02.03.04.05.05l2.76,2.76-2.76,2.76c-.85.82-.87,2.17-.05,3.02.82.85,2.17.87,3.02.05.02-.02.04-.03.05-.05l2.76-2.76,2.76,2.76c.82.85,2.17.87,3.02.05.85-.82.87-2.17.05-3.02-.02-.02-.03-.04-.05-.05l-2.76-2.76,2.76-2.76c.83-.83.83-2.18,0-3.02h0Z"/></g></svg>
										{/* <svg width="20" height="20" viewBox="0 0 20 20" fill='#fff' xmlns="http://www.w3.org/2000/svg">
<path d="M10.0003 10H10.0087M14.167 10H14.1753M5.83366 10H5.84199M3.33366 5H16.667C17.5875 5 18.3337 5.74619 18.3337 6.66667V13.3333C18.3337 14.2538 17.5875 15 16.667 15H3.33366C2.41318 15 1.66699 14.2538 1.66699 13.3333V6.66667C1.66699 5.74619 2.41318 5 3.33366 5Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg> */}
									</div>
									<div  class="text">Enter One Time Pin (OTP)</div>
								</button>
								<div class="subtext">{t("door_key_auth.otp_received_subheading")}</div></>}
								{props.otpEnabled && props.qrOnTVEnabled && <div class="break">OR</div>}
								{props.qrOnTVEnabled &&
								<button onClick={() => props.onOptionClick("QRonTV")}>
									<div class="icon">
										<svg xmlns="http://www.w3.org/2000/svg" id="Layer_1" data-name="Layer 1" viewBox="0 0 24 24" width="512" height="512"><circle cx="12" cy="15" r="4"/><path d="M21,5H3A3,3,0,0,0,0,8V24H24V8A3,3,0,0,0,21,5ZM12,21a6,6,0,1,1,6-6A6.006,6.006,0,0,1,12,21Z"/><polygon points="17.72 3 15.406 0 8.593 0 6.28 3 17.72 3"/></svg>
									</div>
									<div  class="text">Scan QR code displayed on your TV</div>
								</button>}
								{props.fdEnabled && (props.qrOnTVEnabled || props.otpEnabled) && <div class="break">OR</div>}
								{props.fdEnabled &&
								<button onClick={() => props.onOptionClick("FrontdeskAPI")}>
									<div class="icon">
										{/* <svg xmlns="http://www.w3.org/2000/svg" id="Layer_1" data-name="Layer 1" viewBox="0 0 24 24" width="512" height="512"><circle cx="12" cy="15" r="4"/><path d="M21,5H3A3,3,0,0,0,0,8V24H24V8A3,3,0,0,0,21,5ZM12,21a6,6,0,1,1,6-6A6.006,6.006,0,0,1,12,21Z"/><polygon points="17.72 3 15.406 0 8.593 0 6.28 3 17.72 3"/></svg> */}
										<svg id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 38.4 51.2" fill='#010101'><g id="Layer_1-2" data-name="Layer 1"><g><path class="cls-1" d="M19.2,25.6c7.07,0,12.8-5.73,12.8-12.8S26.27,0,19.2,0,6.4,5.73,6.4,12.8c0,7.07,5.73,12.79,12.8,12.8Zm0-21.33c4.71,0,8.53,3.82,8.53,8.53s-3.82,8.53-8.53,8.53-8.53-3.82-8.53-8.53,3.82-8.53,8.53-8.53Z"/><path class="cls-1" d="M19.2,29.87C8.6,29.88,.01,38.47,0,49.07c0,1.18,.96,2.13,2.13,2.13s2.13-.96,2.13-2.13c0-8.25,6.69-14.93,14.93-14.93s14.93,6.69,14.93,14.93c0,1.18,.96,2.13,2.13,2.13s2.13-.96,2.13-2.13c-.01-10.6-8.6-19.19-19.2-19.2Z"/></g></g></svg>
									</div>
									<div  class="text">Validate your self at Front Desk.</div>
								</button>}
								{props.qrSharingEnabled && (props.qrOnTVEnabled || props.otpEnabled || props.fdEnabled) && <div class="break">OR</div>}
								{props.qrSharingEnabled &&
								<button>
									<div class="icon">
										<svg xmlns="http://www.w3.org/2000/svg" id="Layer_1" data-name="Layer 1" viewBox="0 0 24 24" width="512" height="512"><circle cx="12" cy="15" r="4"/><path d="M21,5H3A3,3,0,0,0,0,8V24H24V8A3,3,0,0,0,21,5ZM12,21a6,6,0,1,1,6-6A6.006,6.006,0,0,1,12,21Z"/><polygon points="17.72 3 15.406 0 8.593 0 6.28 3 17.72 3"/></svg>
									</div>
									<div  class="text">Scan QR code displayed on your companion's phone</div>
								</button>}

							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
		</>}
    </div>
  )
}

const mapStateToProps = state => {
    return {
        guestDetail: state.store.home.guestDetails,
        CheckedInGuest: state.store.CheckedInGuest,
        installedAppName: state.store.installedAppName,
        guestIsLoggedIn: state.store2.guestIsLoggedIn,
        loginGuestDetails: state.store2.loginGuestDetails,
		logo: state.store.home.currentDuration.brandingInfo ?
            state.store.home.currentDuration.brandingInfo.hotelLogoImageUrl : "",
        installedAppVersion: state.store.installedAppVersion,
        installedAppBuildNo: state.store.installedAppBuildNo,
        currentWidgets: state.store.sideNavBar.currentWidget,
        currentHomePage: state.store2.currentHomePage,
    }
}

export default connect(mapStateToProps, {currentWidget, sendAnalytics})(withTranslation("translations")(SelectAuthOption));